<template>
  <button
    role="tab"
    :aria-selected="active"
    v-bind="$attrs"
    @click="emit('click')"
    :class="[
      'px-[2px] py-[6px] text-[14px] border-b-2 transition cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600',
      active
        ? 'text-[#191919] font-medium leading-[22px] tracking-[0.28px] border-[#191919]'
        : 'text-[#999999] border-transparent'
    ]"
    data-testid="pdp-taia-tab-button"
  >
    {{ label }}
  </button>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })

const props = defineProps<{
  label: string
  active: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>
